import { EmergencyNotificationConfiguration } from '@dreryk/egabinet-emergency-notification-frontend-api';

import { Checkbox, SecondaryText, StyledFlex, Text } from '@dreryk/react-components';
import { FormContextValues, Translate } from '@dreryk/react-common';

import { translationKeys } from '../../../translations';

import { EmergencyNotificationSmsConfigurationEnabledFieldFormBeanPart } from './EmergencyNotificationSmsConfigurationEnabledField.types';

type EmergencyNotificationSmsConfigurationEnabledFieldProps = Pick<
   FormContextValues<EmergencyNotificationSmsConfigurationEnabledFieldFormBeanPart>,
   'register'
> & {
   readonly emergencyNotificationConfiguration: EmergencyNotificationConfiguration;
};

export const EmergencyNotificationSmsConfigurationEnabledField = (
   props: EmergencyNotificationSmsConfigurationEnabledFieldProps
): JSX.Element => {
   const defaultValue = Boolean(props.emergencyNotificationConfiguration.smsConfiguration.enabled);

   return (
      <StyledFlex gap={'4px'} alignItems={'start'}>
         <Checkbox
            testId={'smsConfigurationEnabled'}
            controller={props.register('smsConfigurationEnabled')}
            defaultValue={defaultValue}
         />
         <StyledFlex direction={'column'}>
            <Text testId={'sendSmsNotifications'}>
               <Translate>{translationKeys.sendSmsNotifications}</Translate>
            </Text>
            <SecondaryText
               testId={'smsNotificationsWillBeSentToTheFollowingPhoneNumbersYouCanAddPeopleFromWorkSecurityOrFamily'}
               text={
                  translationKeys.smsNotificationsWillBeSentToTheFollowingPhoneNumbersYouCanAddPeopleFromWorkSecurityOrFamily
               }
            />
         </StyledFlex>
      </StyledFlex>
   );
};
